import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";

import { InstallationMaalerAflaesningFormBuilder, InstallationMaalerAflaesningMedMaalerType } from "@e-forsyning/common/maaler";

export class FlyttemeddelelseAflaesningFormBuilder {
    public static opretForm(maalerAflaesning: InstallationMaalerAflaesningMedMaalerType, erAflaesningFravalgt: boolean): UntypedFormGroup {
        const result = InstallationMaalerAflaesningFormBuilder.maalerAflaesningToFormGroup(maalerAflaesning, true);
        result.addControl("erAflaesningFravalgt", new UntypedFormControl(erAflaesningFravalgt));
        if (erAflaesningFravalgt) {
            result.disable();
        }
        return result;
    }
}
